// -------------------------------------------------------------------------------------------------
// NortonLifeLock copyright header start
// ----------------------
//
// PROPRIETARY / CONFIDENTIAL.
// Use of this product is subject to license terms.
// Copyright (c) 2022 NortonLifeLock
// All rights reserved.
//
// -------------------------------------------------------------------------------------------------
// NortonLifeLock copyright header stop
// ----------------------
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

const Bullet = styled.div`
  &::before {
    content: attr(data-number);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 1.25rem;
    height: 1.25rem;
    border-radius: 50%;
    background: var(--nll-gray02);
    margin-right: 0.625rem;
    text-indent: 0rem;
    text-align: center;
    color: var(--nll-white);
    font-size: 0.8125rem;
    font-weight: 700;
  }
  text-indent: -1.875rem;
  margin-left: 1.875rem;
  line-height: 1.875rem;
`;

interface IBulletPoint {
  number: string;
  children: React.ReactNode;
}

export const BulletPoint: FunctionComponent<IBulletPoint> = ({ number = '1', children }) => {
  return <Bullet data-number={number}>{children}</Bullet>;
};
